module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.checkinPage ? 'checkin-background' : ''],
    attrs: {
      "id": "app"
    }
  }, [_c('notifications', {
    attrs: {
      "group": "top-right-common",
      "position": "top right",
      "width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('div', {
          class: ['notification', 'custom-notification', props.item.type.notificationType, props.item.type.hideClose ? 'hide-close' : '']
        }, [_c('div', {
          staticClass: "notification-content-wrap"
        }, [_c('div', {
          staticClass: "notification-title"
        }, [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('div', {
          staticClass: "notification-content",
          domProps: {
            "innerHTML": _vm._s(props.item.text)
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "notification-btn-wrap"
        }, [(props.item.type.textCloseBtn) ? _c('div', {
          class: ['notification-close-btn', 'notification-btn', props.item.type.notificationType],
          on: {
            "click": props.close
          }
        }, [_vm._v(_vm._s(props.item.type.textCloseBtn))]) : _vm._e(), _vm._v(" "), (props.item.type.linkBtn) ? _c('div', _vm._l((props.item.type.linkBtn), function(btn, key) {
          return _c('a', {
            key: key,
            class: ['notification-link-btn', 'notification-btn', props.item.type.notificationType],
            attrs: {
              "href": btn.url,
              "target": btn.target
            },
            on: {
              "click": props.close
            }
          }, [_vm._v(_vm._s(btn.btnText))])
        }), 0) : _vm._e()])]), _vm._v(" "), (props.item.type.hideClose !== true) ? _c('div', {
          staticClass: "notification-close",
          on: {
            "click": props.close
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("clear")])]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('loadingDiv', {
    attrs: {
      "type": "full-page-loading"
    }
  }), _vm._v(" "), (!_vm.hideBar) ? _c('mu-appbar', {
    staticClass: "header-content",
    class: {
      'nav-hide': !_vm.open, 'login-page': !_vm.login, 'open': _vm.open
    },
    attrs: {
      "zDepth": 0,
      "title": ""
    }
  }, [(!_vm.login) ? [_c('a', {
    attrs: {
      "href": 'https://www.mondoconnex.com',
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "nav-logo",
    attrs: {
      "slot": "left",
      "src": require("./assets/mondoconnex-menu-logo.svg")
    },
    slot: "left"
  })]), _vm._v(" "), (_vm.$route.path !== '/registration') ? _c('mu-button', {
    staticClass: "top-button mobile-hide",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "slot": "right",
      "textColor": "white",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.changeToPage(_vm.$settings.basicURL + '/registration')
      }
    },
    slot: "right"
  }, [_vm._v("\n        Registration\n      ")]) : _vm._e(), _vm._v(" "), _c('mu-button', {
    staticClass: "top-button mobile-hide",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "slot": "right",
      "textColor": "white",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.changeToPage(_vm.$settings.basicURL + '/login')
      }
    },
    slot: "right"
  }, [_vm._v("\n        Login\n      ")]), _vm._v(" "), _c('mu-button', {
    staticClass: "demo-flat-button menu-icon mobile-show",
    attrs: {
      "slot": "right",
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.toggleNav
    },
    slot: "right"
  }, [_c('mu-icon', {
    attrs: {
      "left": "",
      "value": "menu"
    }
  }), _vm._v("Menu\n      ")], 1)] : _vm._e(), _vm._v(" "), (_vm.login) ? [_c('div', {
    attrs: {
      "id": "nav-title"
    }
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'https://www.mondoconnex.com',
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "nav-logo mobile-show",
    attrs: {
      "slot": "left",
      "src": require("./assets/mondoconnex-menu-logo.svg")
    },
    slot: "left"
  })]), _vm._v(" "), _c('mu-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.desktop),
      expression: "!desktop"
    }],
    staticClass: "menu-icon mobile-hide",
    staticStyle: {
      "color": "black",
      "padding": "0",
      "margin-top": "3px"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.toggleNav
    },
    slot: "right"
  }, [_c('mu-icon', {
    attrs: {
      "left": "",
      "value": "menu"
    }
  })], 1), _vm._v(" "), _c('mu-button', {
    staticClass: "top-button mobile-hide",
    attrs: {
      "slot": "right",
      "textColor": "black"
    },
    on: {
      "click": _vm.logout
    },
    slot: "right"
  }, [_c('mu-icon', {
    attrs: {
      "value": "input",
      "left": ""
    }
  }), _vm._v("Log out\n      ")], 1), _vm._v(" "), _c('mu-button', {
    staticClass: "demo-flat-button menu-icon mobile-show",
    attrs: {
      "slot": "right",
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.toggleNav
    },
    slot: "right"
  }, [_c('mu-icon', {
    attrs: {
      "left": "",
      "value": "menu"
    }
  }), _vm._v("Menu\n      ")], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.hideBar) ? _c('app-nav', {
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked
    },
    on: {
      "change": _vm.handleMenuChange,
      "close": _vm.toggleNav,
      "logout": _vm.logout
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'nav-hide': !_vm.open, 'hide-bar': _vm.hideBar, 'checkin-background': _vm.checkinPage
    },
    style: ({
      'padding-bottom': _vm.login === true && !_vm.hideBar ? '100px' : 'auto'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1), _vm._v(" "), (_vm.login && !_vm.checkinPage) ? _c('div', {
    staticClass: "bottom-image desktop",
    staticStyle: {
      "bottom": "0",
      "position": "fixed",
      "width": "calc(100vw - 256px)",
      "left": "256px"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.login && !_vm.checkinPage) ? _c('div', {
    staticClass: "bottom-image mobile"
  }, [_vm._m(1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://bit.ly/30GsULD",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "80%",
      "max-height": "150px"
    },
    attrs: {
      "src": require("./assets/img/Portal-Banner-Mondo-Menu.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://bit.ly/30GsULD",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "95%",
      "max-height": "150px"
    },
    attrs: {
      "src": require("./assets/img/Portal-Banner-Mondo-Menu.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b574727","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 203
// module chunks = 14